import * as types from './actionTypes';  
import allocationDetailApi from '../api/allocationDetailApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchAllocationDetail(id) {

  return {
    type: types.DO_FETCH_ALLOCATION_DETAIL,
    id
  };
}

export function doFetchAllocationDetailRes(data) {  
  return {
    type: types.DO_FETCH_ALLOCATION_DETAIL_RES, 
    data
  };
}
export function fetchAllocationDetail(id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      allocationDetailApi.doFetchAllocationDetail(id).then(data => {
        dispatch(doFetchAllocationDetailRes(data));
        dispatch(doFetchAllocationDetailRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}